const ACS = 'acs'
const MGD = 'mgd'
const CPM = 'cpm'
const GSA = 'gsa'
const MOBILE = 'mobile'
const DESKTOP = 'desktop'

const getBrandCode = function() {
    return localStorage.getItem('user-brand')
}

const getDevice = function() {
    return localStorage.getItem('user-device')
}

const setBrand = function(brandCode) {
    return localStorage.setItem('user-brand', brandCode)
}

const setDevice = function(device) {
    return localStorage.setItem('user-device', device)
}

const portalUrl = function() {
    switch(getDevice()) {
        case MOBILE:
            return process.env.RETURN_URL_CPM_APP
        default:
            switch(getBrandCode()) {
                case GSA:
                    return process.env.RETURN_URL_GSA + process.env.PORTAL_PATH
                case ACS:
                    return process.env.RETURN_URL_ACS + process.env.PORTAL_PATH
                case MGD:
                    return process.env.RETURN_URL_MGD + process.env.PORTAL_PATH
                default:
                    return process.env.RETURN_URL_CPM + process.env.PORTAL_PATH
            }
    }
}

const isValid = function(brand) {
    switch(brand) {
        case GSA:
            return true
        case ACS:
            return true
        case MGD:
            return true
        case CPM:
            return true
        default:
            return false
    }
}

const connectionUrl = function() {
    switch(getBrandCode()) {
        case GSA:
            return process.env.RETURN_URL_GSA + process.env.CONNECTION_PATH
        case ACS:
            return process.env.RETURN_URL_ACS + process.env.CONNECTION_PATH
        case MGD:
            return process.env.RETURN_URL_MGD + process.env.CONNECTION_PATH
        case CPM:
            return process.env.RETURN_URL_CPM + process.env.CONNECTION_PATH
        default:
            return null
    }
}

const getBrandTitle = function() {
    const brandCode = getBrandCode()
    if(brandCode===ACS)
        return 'ACS - '
    else if (brandCode===GSA)
        return 'GSA - '
    else if (brandCode===MGD)
        return 'MGD - '
    else if (brandCode===CPM)
        return 'CPMS - '
    else
        return ''
}

const getLeftToPayClass = function() {
    switch(getBrandCode()) {
        case GSA:
            return 'gsa-leftToPay'
        case ACS:
            return 'acs-leftToPay'
        case MGD:
            return 'mgd-leftToPay'
        default:
            return 'cpm-leftToPay'
    }
}

const getMainButtonClass = function() {
    switch(getBrandCode()) {
        case GSA:
            return 'gsa-button'
        case ACS:
            return 'acs-button'
        case MGD:
            return 'mgd-button'
        default:
            return 'cpm-button'
    }
}

const getNavClass = function() {
    switch(getBrandCode()) {
        case GSA:
            return 'gsa-nav'
        case ACS:
            return 'acs-nav'
        case MGD:
            return 'mgd-nav'
        default:
            return 'cpm-nav'
    }
}

const getUnderlineClass = function() {
    switch(getBrandCode()) {
        case GSA:
            return 'gsa-underline'
        case ACS:
            return 'acs-underline'
        case MGD:
            return 'mgd-underline'
        default:
            return 'cpm-underline'
    }
}

export default {
    setBrand,
    setDevice,
    getBrandCode,
    getBrandTitle,
    getNavClass,
    getLeftToPayClass,
    getMainButtonClass,
    getUnderlineClass,
    portalUrl,
    connectionUrl,
    ACS,
    MGD,
    CPM,
    GSA,
    MOBILE,
    DESKTOP,
    isValid,
}



// WEBPACK FOOTER //
// ./src/helpers/branding.js